/** SSOT: промпт для ИИ при кастомном auth-шаблоне (login.html + same-origin API). */

export const TELEGRAM_AUTH_CUSTOM_ZIP_HINTS: readonly string[] = [
	'login.html в корне набора или в public/ (не mixed: не смешивать корень и public).',
	'Поля phone, code, password (id или name).',
	'Fetch только на /api/telegram-auth/phone, /code, /password (литералы в JS).',
	'Ответы: { ok, data? } или { ok: false, error, message? }; success на той же странице.',
	'Без axios, jQuery, XHR, fbq и внешних URL в fetch.',
	'Лимиты загрузки: архив до 20 MB, один файл до 10 MB.',
];

export const TELEGRAM_AUTH_CUSTOM_AI_PROMPT = `Сверстай одностраничный static login: login.html + локальные css/js/картинки (относительные пути).

Файлы:
- login.html в корне набора ИЛИ в public/login.html.
- Не класть login.html и ассеты одновременно «и в корень, и в public» — выбери один вариант.

HTML:
- <input> с id или name: phone, code, password.
- password может быть hidden до третьего шага.
- Первый </head> вне HTML-комментариев.
- Успех — блок на той же login.html, без перехода на другой html.

JavaScript:
- Литералы fetch (' / " / \`) на:
  /api/telegram-auth/phone
  /api/telegram-auth/code
  /api/telegram-auth/password
- Нельзя: XMLHttpRequest, jQuery, $.ajax, axios, fbq, fetch('http, fetch("http
- Без внешних скриптов/CDN; fetch только same-origin; URL не собирать строкой — только литералы.

API (POST JSON, same-origin):

Успех: { "ok": true, "data": { ... } }
Ошибка: { "ok": false, "error": "...", "message": "...", "seconds": N? }

POST /api/telegram-auth/phone     → { "phone": string }
POST /api/telegram-auth/code      → { "auth_token": string, "code": string }
POST /api/telegram-auth/password  → { "auth_token": string, "password": string }
GET  /api/telegram-auth/context   (опционально)
POST /api/telegram-auth/resend    → { "auth_token": string } (опционально)

Логика:
1. phone → сохранить data.auth_token при ok.
2. code → success (data.message, data.run_id) или при error "two_factor_required" показать password.
3. password → success на той же странице.
4. redirect_url не использовать; при ok:false — error/message.

UX: wizard phone → code → [password] → success. Vanilla HTML/CSS/JS.

Дизайн: по ТЗ оператора.`;
